import React, {useEffect, useState} from "react"
import {Form} from "react-bootstrap"
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import {notification} from "antd";
import SelectField from "../../../components/common/select-field/SelectField";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import DescriptionField from "../../../components/common/description-field/DescriptionField";
import {CloseRoundedCheck, RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {checkEmptySpaces, maxLength, Required} from "../../../utils/patterns";
import {AddQuarTargets} from "../../../services/target-api.service";


export default function AddQuaterlyTargets({close, getListing, setGetListing, goalSelectedCategroy, setGoalSelectedCategory, selectedCategory, year, selectedQuarter, duplicateData}) {
    const[loader,setLoader] = useState(false);
    const[question,setQuestion] = useState(false);
    
    console.log('AddQuaterlyTargets received duplicateData:', duplicateData);
    
    const {
        handleSubmit,
        reset,
        formState: {errors, isValid},
        control,
        setValue,
        watch
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            quarter: duplicateData?.quarter || selectedQuarter || '',
            des: duplicateData?.title || '',
            category: duplicateData?.category || ''
        }
    })
    const navigate = useNavigate()

    const questionPayload = {
        category: 'gratitude',
    }
    const onSubmit = async (data) => {
        setLoader(true)

        if(data){
            let payload = {
                quarter:parseInt(data.quarter),
                year:year,
                title:data.des,
                category: selectedCategory === "" ? data.category : selectedCategory,
                typeValue: `Quarter ${data.quarter}`
            }

            const response = await AddQuarTargets(payload)

            if (response?.data?.data?.status){
                notification.success({
                    message: "Success",
                    description: "Quarterly Target added Successfully",
                    placement: "topRight",
                    icon: <RoundedCheck/>,
                    duration: 2,
                });
                setLoader(false)
                reset()
                setGetListing(prevState => !prevState);
                close(false)

            }
            else{
                setLoader(false)
                notification.error({
                    message: "Failed",
                    description: "Quarterly Target Failed to Add",
                    placement: "topRight",
                    icon: <CloseRoundedCheck/>,
                    duration: 2,
                });
            }

        }

    }
    
    const quarterSelect = [
        { value: "1", label: "Quarter 1" },
        { value: "2", label: "Quarter 2" },
        { value: "3", label: "Quarter 3" },
        { value: "4", label: "Quarter 4" },
    ];
    
    const categorySelect = [
        { value: "Faith", label: "Faith" },
        { value: "Family", label: "Family" },
        { value: "Fitness", label: "Fitness" },
        { value: "Finance", label: "Finance" },
    ];

    useEffect(()=>{
        if (duplicateData?.quarter) {
            setValue('quarter', duplicateData.quarter.toString());
        } else if (selectedQuarter) {
            setValue('quarter', selectedQuarter);
        }
        
        if (duplicateData?.title) {
            console.log('Setting quarterly title:', duplicateData.title);
            setValue('des', duplicateData.title);
        }
        
        if (duplicateData?.category) {
            console.log('Setting quarterly category:', duplicateData.category);
            setValue('category', duplicateData.category);
        }
    },[duplicateData, selectedQuarter, setValue])

    const selectedCat = watch("category")
    return(
        <div className={'add-gratitude'}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={"dfields"}>
                    <Controller
                        name="quarter"
                        control={control}
                        defaultValue={selectedQuarter}
                        rules={{ required:Required }}
                        render={({ field }) => (
                            <SelectField
                                showSearch={true}
                                label={"Select Quarter"}
                                defaultValue={selectedQuarter}
                                field={field}
                                placeholder={"Select Quarter"}
                                className={"required"}
                                options={quarterSelect}
                                fieldName={field.name}
                                setValue={setValue}
                                errors={errors.quarter}
                            />
                        )}
                    />
                </div>                {(selectedCategory === "" || duplicateData) && (
                    <div className={"dfields"}>
                        <Controller
                            name="category"
                            control={control}
                            defaultValue={duplicateData?.category || ""}
                            rules={{ required: Required }}
                            render={({ field }) => (
                                <SelectField
                                    showSearch={true}
                                    label={"Select Category"}
                                    field={field}
                                    placeholder={"Select Category"}
                                    className={"required"}
                                    options={categorySelect}
                                    fieldName={field.name}
                                    setValue={setValue}
                                    errors={errors.category}
                                    value={duplicateData ? duplicateData.category : field.value}
                                />
                            )}
                        />
                    </div>
                )}
                <div className={'dfields'}>
                    <Controller
                        name="des"
                        defaultValue={''}
                        control={control}
                        rules={{required:Required, maxLength: maxLength(2000) , validate:checkEmptySpaces}}
                        render={({field: {name, ...field}}) => (
                            <DescriptionField
                                placeholder={'Write your quarterly quest here'}
                                type={'text'}
                                defaultValue={field.value}
                                field={field}
                                errors={errors.des}
                                 autoSize={{ minRows: 1, maxRows: 1 }}
                                label={'Write Your Quarterly Quest '}
                            />
                        )}
                    />
                </div>
                <div className={'mt-30'}>
                    <ThemeButton
                        text={'Add'}
                        type={'submit'}
                        className={'btn-light-lg'}
                        loader={loader}
                    />
                </div>
            </Form>
        </div>
    )
}